import React, { useState } from 'react';
import { Box, Flex, Text, Input, InputGroup, InputRightElement, IconButton, Checkbox, Button, Link } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  return <Box w="100vw" h="100vh" bg="white" overflow="auto" data-id="element-299">
      {/* Reuse the same teal header */}
      <Header data-id="element-300" />

      {/* Page content below header */}
      <Box pt="64px" px={6} py={6} data-id="element-301">
        {/* Outer card — dark teal border, upper-left positioned */}
        <Box border="2px solid #006666" borderRadius="md" bg="white" maxW="620px" p={6} className="mt-[100px] mb-[100px] ml-[37px] mr-[37px]" data-id="element-302">
          {/* Sign In heading */}
          <Text fontSize="2xl" fontWeight="bold" color="black" mb={1} data-id="element-303">
            Sign In
          </Text>

          {/* Register link row */}
          <Flex align="center" gap={1} mb={5} data-id="element-304">
            <Text fontSize="md" color="black" data-id="element-305">
              Don't have an account?
            </Text>
            <Link href="#" color="blue.600" fontWeight="bold" fontSize="md" textTransform="uppercase" letterSpacing="0.03em" _hover={{
            textDecoration: 'underline'
          }} data-id="element-306">
              Register
            </Link>
          </Flex>

          {/* Inner form box */}
          <Box border="1px solid #ccc" borderRadius="sm" p={5} mb={4} data-id="element-307">
            {/* Email */}
            <Box mb={4} borderBottom="1px solid #ccc" pb={2} data-id="element-308">
              <Input variant="unstyled" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} fontSize="md" color="gray.600" _placeholder={{
              color: 'gray.500'
            }} data-id="element-309" />
            </Box>

            {/* Password */}
            <Box mb={5} borderBottom="1px solid #ccc" pb={2} data-id="element-310">
              <InputGroup data-id="element-311">
                <Input variant="unstyled" placeholder="Password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} fontSize="md" color="gray.600" _placeholder={{
                color: 'gray.500'
              }} data-id="element-312" />
                <InputRightElement data-id="element-313">
                  <IconButton aria-label={showPassword ? 'Hide password' : 'Show password'} icon={showPassword ? <EyeOff size={18} data-id="element-315" /> : <Eye size={18} data-id="element-316" />} variant="ghost" size="sm" color="gray.500" onClick={() => setShowPassword(!showPassword)} _hover={{
                  bg: 'transparent'
                }} data-id="element-314" />
                </InputRightElement>
              </InputGroup>
            </Box>

            {/* Remember Me + Forgot Password row */}
            <Flex align="center" justify="space-between" mb={5} data-id="element-317">
              <Checkbox isChecked={rememberMe} onChange={e => setRememberMe(e.target.checked)} colorScheme="gray" size="md" data-id="element-318">
                <Text fontSize="sm" color="black" data-id="element-319">
                  Remember Me
                </Text>
              </Checkbox>
              <Link color="blue.600" fontSize="sm" fontWeight="semibold" cursor="pointer" onClick={() => navigate('/forgot')} _hover={{
              textDecoration: 'underline'
            }} data-id="element-320">
                Forgot Password?
              </Link>
            </Flex>

            {/* Sign In button */}
            <Flex justify="center" data-id="element-321">
              <Button bg="#0d6dfc" color="white" _hover={{
              bg: '#0b5fd9'
            }} _active={{
              bg: '#0a52be'
            }} px={10} borderRadius="md" fontSize="md" fontWeight="semibold" onClick={() => navigate('/welcome')} data-id="element-322">
                Sign In
              </Button>
            </Flex>
          </Box>

          {/* Disclaimer text */}
          <Text fontSize="sm" color="#008B45" fontStyle="italic" mb={5} lineHeight="1.5" data-id="element-323">
            This site is for the exclusive use of authorized processors working
            with USA Dry Pea &amp; Lentil. If you are not an authorized user,
            please leave now.
          </Text>

          {/* Warning banner */}
          <Box bg="#FF3300" borderLeft="6px solid #8B008B" borderRadius="sm" px={4} py={3} data-id="element-324">
            <Text fontWeight="bold" color="black" fontSize="md" data-id="element-325">
              Unauthorized access or access attempt is against the law.
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>;
}